import { combineReducers } from 'redux';
import listReducer, { ListState } from '../../List/listReducer';
import comparisonReducer, {
    ComparisonState,
} from '../../Comparison/comparisonReducer';
import filterReducer, { FilterState } from '../../Filter/filterReducer';
import appConfigReducer, {
    AppConfigState,
} from '../../AppConfig/appConfigReducer';
import catalogReducer, { CatalogState } from '../../Catalog/catalogReducer';

export interface RootState {
    list: ListState;
    comparison: ComparisonState;
    filters: FilterState;
    appConfig: AppConfigState;
    catalog: CatalogState;
}

export type GetState = () => RootState;

const rootReducer = () => {
    return combineReducers({
        list: listReducer,
        comparison: comparisonReducer,
        filters: filterReducer,
        appConfig: appConfigReducer,
        catalog: catalogReducer,
    });
};

export default rootReducer;
